module.exports = __webpack_public_path__ + "img/contents-2@3x.5c2388f2.png";